export default __webpack_public_path__ + "76b7080.png";